import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                 from '../../api/api.service';
import { CustomerModel }              from '../../customers/models/customer';
import { HtmlToPlainTextPipe }        from '../../shared/pipes/html-to-plain-text.pipe';
import { MessengerEmailComponent }    from './messenger.email.component';
import { MessengerEmailOptionsModel } from './typings/messenger.email-options';
import { MessengerEmailParamsModel }  from './typings/messenger.email-params';
import { MessengerSmsComponent }      from './messenger.sms.component';
import { MessengerSmsOptionsModel }   from './typings/messenger.sms-options';
import { MessengerSmsParamsModel }    from './typings/messenger.sms-params';
import { RecpatchaService }           from '../../recaptcha/recaptcha.service';

@Injectable({
  providedIn: 'root'
})
export class MessengerService {
  emailOptions : MessengerEmailOptionsModel = {
    bodyParamName: 'email',
    factory      : MessengerEmailComponent,
    size         : 'md',
    templateKey  : 'email',
    url          : '/system/send_email'
  };

  smsOptions : MessengerSmsOptionsModel = {
    factory: MessengerSmsComponent,
    size   : 'md'
  };

  constructor (
    private apiService         : ApiService,
    private htmlToPlainTextPipe: HtmlToPlainTextPipe,
    private modalService       : NgbModal,
    private recaptchaService   : RecpatchaService
  ) {}

  email ( email : MessengerEmailParamsModel = {}, options : MessengerEmailOptionsModel = {} ) : Promise<any> {
    const mergedOptions = this.getMergedOptions(options);
    const windowClass   = `${ mergedOptions.size }-modal`;

    email.subject = this.htmlToPlainTextPipe.transform(email.subject);

    const modalRef = this.modalService.open(mergedOptions.factory, {
      windowClass: windowClass
    });

    modalRef.componentInstance.email   = email;
    modalRef.componentInstance.options = mergedOptions;

    return modalRef.result;
  }

  getMergedOptions ( options : MessengerEmailOptionsModel = {} ) : MessengerEmailOptionsModel {
    return Object.assign({}, this.emailOptions, options);
  }

  sendBulkSms ( customers : Array<CustomerModel>, message : string ) : Promise<any> {
    return this.recaptchaService.verifyUser()
    .then(( verified : boolean ) => this.apiService.post('/sms_logs/send_bulk_sms', {
      customer_list: customers,
      message
    }, 'customers'));
  }

  sendEmail ( email : MessengerEmailParamsModel, options : MessengerEmailOptionsModel = {} ) : Promise<any> {
    const mergedOptions = this.getMergedOptions(options);

    return this.recaptchaService.verifyUser()
    .then(( verified : boolean ) => this.apiService.post(
      mergedOptions.url,
      email,
      mergedOptions.bodyParamName
        ? mergedOptions.bodyParamName
        : null
    ));
  }

  sendSms ( sms : MessengerSmsParamsModel ) : Promise<any> {
    return this.recaptchaService.verifyUser()
    .then(( verified : boolean ) => this.apiService.post('/sms_logs/send', sms, 'sms'));
  }

  sms ( sms : MessengerSmsParamsModel, options : MessengerSmsOptionsModel = {} ) : Promise<any> {
    options = Object.assign({}, this.smsOptions, options);

    const modalRef = this.modalService.open(options.factory, {
      windowClass: `${ options.size }-modal`
    });

    modalRef.componentInstance.sms = sms;

    return modalRef.result;
  }
}
